import { fetchOfferExtraById } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { sum } from 'lib/array/arrayUtils'
import { useEffect } from 'react'

export function useNumBookedToday(offerId: string) {
  const offerExtras = useAppSelector((state) => state.offer.offerExtras[offerId])
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (offerId && !offerExtras) {
      dispatch(fetchOfferExtraById(offerId))
    }
  }, [offerId, offerExtras, dispatch])

  const numBookedToday = sum(offerExtras?.data?.roomsPurchasesToday ?? [], (val) => val.purchases)

  return {
    numBookedToday,
    loading: offerExtras?.state === 'loading',
  }
}
